import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { MEETINGS_DETAIL_TOUR_ID } from './detail';
import { MEETINGS_LIST_TOUR_ID } from './list';
import {
  attendeesStep,
  combinedTableStep,
  contentStep,
  filtersStep,
  headerActionsStep,
  metadataStep,
  newMeetingStep,
} from './steps';

export const MEETINGS_COMBINED_TOUR_ID = 'meetings.combined';

registerTour({
  id: MEETINGS_COMBINED_TOUR_ID,
  name: 'Meeting Minutes',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.MEETING_MINUTES.id,
  alsoMarks: [MEETINGS_LIST_TOUR_ID, MEETINGS_DETAIL_TOUR_ID],
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Meeting Minutes',
      body:
        'Plan project meetings, track who attended, and keep a permanent ' +
        'record of agendas, summaries, decisions, and action items.',
    },
    newMeetingStep,
    filtersStep,
    combinedTableStep,
    headerActionsStep,
    metadataStep,
    attendeesStep,
    contentStep,
  ],
});
